import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import data from "../../Data/pay/payData.json";

export default function Pay() {
  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Платные медицинские услуги
      </h1>

      <div>
        <Accordion data={data} />
      </div>
    </section>
  );
}
